import React from "react";
import { CalendarCheck, QrCode, Clock, ArrowRight } from "lucide-react";
import { SectionWrap, WButton } from "../theme";

// Phase 83 — section « Réservations » : passerelle vers le module de réservation du mini-site PAG
export function BookingSection({ section, preview }) {
  const d = section.data || {};
  const r = d.reservation || {};
  if (!r.available && !preview) return null;
  return (
    <SectionWrap section={section} muted>
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center" data-testid="ws-booking-box">
        <div>
          {d.intro && <p className="text-base lg:text-lg opacity-85">{d.intro}</p>}
          <ul className="mt-5 grid sm:grid-cols-3 gap-3 text-sm">
            <li className="flex items-start gap-2 p-3" style={{ background: "var(--w-card)", border: "1px solid var(--w-border)", borderRadius: "var(--w-radius)" }}><CalendarCheck className="h-4 w-4 mt-0.5 shrink-0" style={{ color: "var(--w-primary)" }} /><span><b>{r.labels?.units || "Hébergements"}</b><br /><span className="opacity-70">disponibilités en temps réel</span></span></li>
            <li className="flex items-start gap-2 p-3" style={{ background: "var(--w-card)", border: "1px solid var(--w-border)", borderRadius: "var(--w-radius)" }}><QrCode className="h-4 w-4 mt-0.5 shrink-0" style={{ color: "var(--w-primary)" }} /><span><b>QR code d'arrivée</b><br /><span className="opacity-70">reçu par email</span></span></li>
            {d.show_info !== false && <li className="flex items-start gap-2 p-3" style={{ background: "var(--w-card)", border: "1px solid var(--w-border)", borderRadius: "var(--w-radius)" }}><Clock className="h-4 w-4 mt-0.5 shrink-0" style={{ color: "var(--w-primary)" }} /><span><b>Arrivée dès {r.checkin_time}</b><br /><span className="opacity-70">départ avant {r.checkout_time}</span></span></li>}
          </ul>
        </div>
        <div className="flex flex-col items-start lg:items-end gap-3">
          {r.available ? (
            <WButton as="a" href={r.url} size="lg" data-testid="ws-booking-cta">{d.button_label || "Réserver en ligne"} <ArrowRight className="h-4 w-4" /></WButton>
          ) : (
            <div className="text-xs p-3 bg-[#FFFBEB] text-[#B45309] border border-[#F59E0B]/40" data-testid="ws-booking-unavailable">Aperçu : le module de réservation n'est pas actif sur votre mini-site (menu « Mini-site public »). Cette section est masquée pour les visiteurs.</div>
          )}
          <div className="text-[11px] opacity-60">Réservation sécurisée via votre espace PAG</div>
        </div>
      </div>
    </SectionWrap>
  );
}
